/**
 * Textos e metadados do Console de Administração (cabine SaaS).
 * Separado do menu lateral "Organização" (gestão da empresa logada).
 */

export const ADMIN_SAAS_DEFAULT_SUBTITLE =
  'Painel do Sistema • Controle de métricas, licenças e instâncias do SaaS';

/** Subtítulo contextual por rota (prefix match). */
export function getAdminPageSubtitle(pathname: string): string {
  if (pathname.startsWith('/administracao/dashboard') || pathname === '/administracao') {
    return 'Dashboard SaaS • MRR, ARR, churn e saúde global da plataforma';
  }
  if (pathname.startsWith('/administracao/clientes')) {
    return 'Workspaces • Empresas cadastradas na plataforma, planos e limites de usuários';
  }
  if (pathname.startsWith('/administracao/licencas') || pathname.startsWith('/administracao/billing')) {
    return 'Comercial • Licenças, billing e assinaturas dos workspaces';
  }
  if (pathname.startsWith('/administracao/pessoas') || pathname.startsWith('/administracao/governanca-tempos')) {
    return 'Governança global • Usuários e políticas de tempo em toda a plataforma';
  }
  if (pathname.startsWith('/administracao/seguranca') || pathname.startsWith('/administracao/auditoria')) {
    return 'Segurança da plataforma • Permissões, políticas e trilha de auditoria';
  }
  if (pathname.startsWith('/administracao/templates') || pathname.startsWith('/administracao/sistema')) {
    return 'Sistema • Templates globais e monitoria da infraestrutura';
  }
  if (
    pathname.startsWith('/administracao/plataforma')
    || pathname.startsWith('/administracao/integracao')
    || pathname.startsWith('/administracao/marketplace')
  ) {
    return 'Plataforma • Integrações, marketplace e ferramentas para operadores do SaaS';
  }
  return ADMIN_SAAS_DEFAULT_SUBTITLE;
}
